import httpAuth from '../../services/httpAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import {
    getExposureError,
    getExposureSuccess,
} from './racePage.slice'

export const requestRaceExposure = (eventId) => async (dispatch, getState) => {
    const userId = getState().user.memberCode;
    if(userId) {
        try {
            // twitter-config - in another reqest if news tab opened
            const userId = getState().user.memberCode;
            httpAuth.get(`/exposure/pnl/${userId}/event/${eventId}`)
                .then(res => {
                    if (res.data.success) {
                        dispatch(getExposureSuccess(res.data.result))
                    }
                })
            return
        } catch (e) {
            dispatch(getExposureError())
            // const errorMsg = getErrorMessage(e)
            // throw errorMsg
        }
    }
}
